import Vue from "vue";
import Vuex from "vuex";
import $http from "axios";
import $api from "./config/api";
import $qs from "qs";

import state from "./utlis/store/state"
import mutations from "./utlis/store/mutations"
import actions from "./utlis/store/actions"


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      ...state,
        userInfo: window.sessionStorage.getItem("login-user-info"),
        brandOwnerProduct: [],
        countryList: [],
        userList: [],
        dictList: [],
        supportLangList: [],
        productList: [],
        sysRoleList: [],
        subBrandList: [],
        brandProductTree: [],
        recipeUnit: [],
        makeModeDict: [],
        recipeTagListByLang: [],
        sysSetLang: [],
        boUnits: [],
        sysUnits: [],
        devModes: {},
        keepAliveInclude: [],
        recipe: {},
        // 热风
        hostWindMode: []
    },
    mutations: {
      ...mutations,
        CHANGE_RECIPE(state, recipe) {
          // state.recipe = {...state.recipe, ...recipe};
          state.recipe = Object.assign({}, state.recipe, recipe);
        },
        CLEAR_RECIPE(state) {
          state.recipe = {};
        },
        CHANGE_KEEP_ALIVE_INCLUDE(state, {type, value}) {
            if(type === "add") {
                if(state.keepAliveInclude.indexOf(value) === -1) {
                    state.keepAliveInclude.push(value);
                }
            } else {
                let index = state.keepAliveInclude.indexOf(value);
                if (index > -1) state.keepAliveInclude.splice(index, 1);
            }
        },
        ADD_SYS_SET_LANG(state, list) {
            state.sysSetLang = list;
        },
        ADD_RECIPE_TAG(state, list) {
            state.recipeTagListByLang = list;
        },
        ADD_MAKE_MODE(state, list) {
            console.log('ADD_MAKE_MODE', list);
            state.makeModeDict = list;
        },
        ADD_USER_INFO(state, info) {
            state.userInfo = info;
        },
        ADD_BRAND_OWNER_PRODUCT(state, list) {
            state.brandOwnerProduct = list;
        },
        ADD_COUNTRY(state, list) {
            state.countryList = list;
        },
        ADD_USER_LIST(state, list) {
            state.userList = list;
        },
        ADD_DICT_LIST(state, list) {
            state.dictList = list;
        },
        ADD_SUPPORT_LANG_LIST(state, list) {
            state.supportLangList = list;
        },
        ADD_PRODUCT_LIST(state, list) {
            state.productList = list;
        },
        ADD_SYS_ROLE_LIST(state, list) {
            state.sysRoleList = list;
        },
        ADD_SUB_BRAND_LIST(state, list) {
            state.subBrandList = list;
        },
        ADD_BRAND_PRODUCT_TREE(state, list) {
            state.brandProductTree = list;
        },
        ADD_RECIPE_UNIT(state, list) {
            state.sysUnits = list;
            this.dispatch('UPDATE_UNIT');
        },
        UPDATE_UNIT(state, list) {
            state.recipeUnit = list.concat(state.sysUnits);
        },
        UPDATE_DEV_MODES(state, list) {
            state.devModes = list;
        },
        ADD_HOST_WIND_MODE(state, list) {
          state.hostWindMode = list;
        }
    },
    actions: {
      ...actions,
        async UPDATE_UNIT(ctx) {
            let resp = await $http.post($api.boUnit.list, $qs.stringify({onPage: false}));
            if (resp.data.status === 200) {
                this.boUnits = resp.data.data.boUnits;
                let units = [];
                this.boUnits.forEach((e) => {
                    units.push({value: e.name, name: e.name});
                });
                ctx.commit('UPDATE_UNIT', units)
            }

        },
        async LOAD_DEV_MODES(ctx) {
            let resp = await $http.post($api.cofarSdk.allDevModes, $qs.stringify({onPage: false}));
            if (resp.data.status === 200) {
                ctx.commit('UPDATE_DEV_MODES', resp.data.data.modes);
            }
        },
    },
    getters: {
      // 获取支持语言
      supportLang(state) {
        let sysLang = state.sysSetLang;
        let supportLangList = state.supportLangList;
        if(sysLang.length) {
          return supportLangList.filter(i =>  sysLang.includes(i.value));
        }
        return supportLangList;
      },

      // 翻译目前只支持 000
      hasTranslate() {
        // const userInfo = state.userInfo;
        // if(['000', '00T'].includes(userInfo.brandOwnerNumber)) return true;
        // return false;
        return true;
      },

      // 根据食谱类型获取产品型号
      getProductModelByRecipeType(state) {
        const list = state.brandOwnerProduct;
        const recipe = state.recipe;
        if(!Array.isArray(list) || !list.length || !recipe.type) return [];
        return list.filter(item => {
          return item.recipeTypes.split(",").includes(recipe.type);
        })
        // return list.filter(item => item.productType === recipe.type);
      }
    }
});
